import {styled, mq} from '../../../utils';
import {Main} from '../../Layout';
import {padding} from 'polished';

export default styled(Main)<{narrow?: boolean}>(({narrow}) => ({
  ...padding(0, 15),
  [mq('laptop')]: padding(0, narrow ? 180 : 80),
  [mq('desktop')]: padding(0, narrow ? 280 : 180)
}));



// WEBPACK FOOTER //
// ./src/components/AuthLayout/Main/Main.tsx